import React, { useState } from "react";
import Section from "../Section";
import { Link } from "gatsby";
import { pages } from "../../../src/data/page";
import Navigation from "../Navigation";
import Hamburger from "../Hamburger";
import Icon from "../Icon";

const Header = () => {
  const [toggled, setToggled] = useState(false);
  const handleToggle = () => {
    setToggled(!toggled);
  };
  return (
    <Section
      as="header"
      variant="sections.header"
      containerSx={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        pb: 0,
        position: "static",
        pt: 0,
      }}
      sx={{
        "~ main": {
          mt: 9,
        },
        // bg: "secondary",
        boxShadow: 2,
        color: "black",
        display: "flex",
        top: 0,
        left: 0,
        mb: 0,
        mt: 0,
        pb: [2, null, null, 2, 2],
        position: "fixed",
        pt: [2, null, null, 2, 2],
        right: 0,
        zIndex: 5,
      }}
    >
      <Link to="/">
        <Icon alt="team" svg="Nsg-logo-green" />
      </Link>
      {pages && pages.length > 0 && (
        <Navigation navLinks={pages} onClick={handleToggle} toggled={toggled} />
      )}
      <Hamburger
        innerSx={{ m: 2 }}
        onClick={handleToggle}
        sx={{
          borderRadius: 1,
          color: "white",
          display: ["inline-block", null, null, "none"],
          flex: "none",
          position: "sticky",
          width: "40px",
        }}
        toggled={toggled}
      />
    </Section>
  );
};

export default Header;
